import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-day-statistics',
  templateUrl: './day-statistics.component.html',
  styleUrls: ['./day-statistics.component.scss'],
  standalone: false,
})
export class DayStatisticsComponent {
  @Input() statistics: any = null;
  @Input() selectedDate: Date | null = null;
  @Input() selectedSector: any = null;
  @Input() workloadData: any = null;
  @Input() loading = false;

  public moment = require('moment');

  get formattedDate(): string {
    if (!this.selectedDate) return '';
    return this.moment(this.selectedDate).format('DD MMMM');
  }

  get sectorNumber(): string {
    return this.selectedSector.sector_number_str || '';
  }

  get workloadPercent(): number {
    if (!this.workloadData) return 0;
    const totalHours = this.workloadData.totalHours || 0;
    const busyHours = this.workloadData.busyHours || 0;
    if (totalHours === 0) return 0;
    return Math.round((busyHours / totalHours) * 100);
  }

  get hasWorkloadData(): boolean {
    return this.workloadData && this.workloadData.totalHours > 0;
  }

  get totalHours(): number {
    return this.workloadData.totalHours || 0;
  }

  get busyHours(): number {
    return this.workloadData.busyHours || 0;
  }

  get unusedHours(): number {
    if (!this.workloadData) return 0;
    const totalHours = this.workloadData.totalHours || 0;
    const busyHours = this.workloadData.busyHours || 0;
    const diff = Math.max(0, totalHours - busyHours);
    return Math.round(diff * 10) / 10;
  }

  get totalTickets(): number {
    if (!this.statistics) return 0;
    return (
      (this.statistics.connection_tickets || 0) + (this.statistics.additional_orders || 0) + (this.statistics.local_applications || 0) + (this.statistics.global_problems || 0)
    );
  }

  get connectionTickets(): number {
    return this.statistics.connection_tickets || 0;
  }

  get additionalOrders(): number {
    return this.statistics.additional_orders || 0;
  }

  get localApplications(): number {
    return this.statistics.local_applications || 0;
  }

  get globalProblems(): number {
    return this.statistics.global_problems || 0;
  }
}
